import React from 'react'
import { motion } from "framer-motion"
import Banner from '../components/Banner'

const Kurumsal = () => {
    // Define animation variants with staggerChildren for sequential animations
    const containerVariant = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 1, // Time delay between animations of children
            },
        },
    }

    const fadeIn = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
    }

    return (
        <div className='bg-white'>
            <Banner />

            <div className='inner-container'>
                <motion.div
                    className='w-full bg-white space-y-16'
                    variants={containerVariant}
                    initial="hidden"
                    whileInView="visible"
                >
                    {/* Hakkımızda Section */}
                    <motion.div variants={fadeIn}>
                        <motion.h2 className='general-heading' variants={fadeIn}>Hakkımızda</motion.h2>
                        <motion.p className='text-base text-p text-gray-500' variants={fadeIn}>
                            Tedak Teknolojik Elektrik Dağıtım Kabinleri, elektrik dağıtım, izleme ve kontrol sistemlerinin projelendirilmesi, üretimi, montajı ve devreye alınması alanlarında uzmanlaşmış bir mühendislik firmasıdır.
                            <div className='h-3' />
                            2012 yılından bu yana; sanayi tesislerinden altyapı projelerine, enerji yatırımlarından kritik tesislere kadar geniş bir yelpazede <strong>güvenilir, sürdürülebilir ve yüksek performanslı çözümler</strong> üretmektedir.
                            <div className='h-3' />
                            4000 m² kapalı ve 1100 m² açık alana sahip modern üretim tesisimizde; uzman mühendislik kadromuz ve nitelikli teknik ekibimizle, <strong>Siemens Sivacon Technology Partner</strong> iş birliği kapsamında <strong>Sivacon S8 çekmeceli, Sivacon S4 ve Alpha Tip Testli</strong> elektrik panolarının sistem entegratörlüğünü gerçekleştiriyoruz.
                            <div className='h-3' />
                            Tüm üretim süreçlerimiz; uluslararası standartlara, kalite kontrol prosedürlerine ve uzun ömürlü kullanım esasına göre planlanmaktadır.
                            <div className='h-3' />
                            Kurulduğumuz günden bu yana yaklaşımımız; yalnızca ürün üretmek değil, <strong>uçtan uca mühendislik çözümleri</strong> sunmak olmuştur. Projelendirme aşamasından başlayarak, üretim, montaj, test ve devreye alma süreçlerinin tamamında; sistem güvenliği, enerji sürekliliği ve operasyonel verimlilik önceliğimizdir.
                            <div className='h-3' />
                            Her proje, ihtiyaca özel mühendislik bakış açısıyla ele alınır ve sahadaki gerçek koşullara göre optimize edilir.
                            <div className='h-3' />
                            Teknolojik gelişmeleri ve sektörel yenilikleri yakından takip eden Tedak, dijitalleşmiş üretim ve montaj süreçleriyle yüksek katma değerli çözümler üretmektedir. Süreç optimizasyonu, minimum enerji kaybı sağlayan sistem tasarımları ve uzun vadeli işletme güvenliği, mühendislik anlayışımızın temelini oluşturur.
                        </motion.p>
                    </motion.div>

                    {/* Misyonumuz Section */}
                    <motion.div id='Misyonumuz' variants={fadeIn}>
                        <motion.h2 className='general-heading' variants={fadeIn}>Misyonumuz</motion.h2>
                        <motion.p className='text-p text-gray-500' variants={fadeIn}>
                            Elektrik dağıtım ve kontrol sistemlerinde; mühendislik disiplinini, ileri teknolojiyi ve kalite standartlarını merkeze alarak, müşterilerimize <strong>güvenli, sürdürülebilir ve uzun ömürlü çözümler</strong> sunmak.
                            <div className='h-3' />
                            Projelerin her aşamasında enerji sürekliliğini, sistem güvenliğini ve operasyonel verimliliği esas alan bir iş ortağı olarak değer üretmek.
                        </motion.p>
                    </motion.div>

                    {/* Vizyonumuz Section */}
                    <motion.div variants={fadeIn}>
                        <motion.h2 className='general-heading' variants={fadeIn}>Vizyonumuz</motion.h2>
                        <motion.p className='text-p text-gray-500' variants={fadeIn}>
                            Mühendislik gücü, teknoloji partnerlikleri ve sürdürülebilir üretim yaklaşımıyla;
                            <div className='h-3' />
                            Türkiye'de ve global pazarlarda <strong>elektrik dağıtım sistemleri alanında güvenilen, referans gösterilen ve tercih edilen</strong> bir marka olmak.
                            <div className='h-3' />
                            Enerji altyapılarının geleceğini şekillendiren, yenilikçi ve sorumluluk sahibi çözümlerle sektöre yön vermek.
                        </motion.p>
                    </motion.div>

                    {/* Sürdürülebilirlik Yaklaşımımız Section */}
                    <motion.div variants={fadeIn}>
                        <motion.h2 className='general-heading text-3xl' variants={fadeIn}>Sürdürülebilirlik Yaklaşımımız</motion.h2>
                        <motion.p className='text-p text-gray-500' variants={fadeIn}>
                            Tedak'ta sürdürülebilirlik, yalnızca çevresel bir sorumluluk değil; mühendislik, operasyon ve kurumsal kültürün ayrılmaz bir parçasıdır.
                            <div className='h-3' />
                            2025 baz yılına göre karbon emisyonlarını %90 oranında azaltma hedefi doğrultusunda, çatı tipi GES yatırımıyla elektrik ihtiyacımızın %90'ını yenilenebilir enerjiden karşılamaktayız. Elektrikli araç filomuz ve enerji verimliliği odaklı uygulamalarımızla karbon ayak izimizi sistematik olarak azaltıyoruz.
                            <div className='h-3' />
                            Üretim süreçlerimizde atıkların ayrıştırılması ve lisanslı bertaraf tesislerine yönlendirilmesi sağlanırken, geri dönüşümden elde edilen gelirler sosyal sorumluluk ve eğitim destek projelerine aktarılmaktadır.
                            <div className='h-3' />
                            Bu yaklaşım, Tedak'ın yalnızca bugünü değil, geleceği de planlayan bir mühendislik anlayışına sahip olduğunu yansıtır.
                        </motion.p>
                    </motion.div>

                    {/* İnsan, Bilgi ve Süreklilik Section */}
                    <motion.div variants={fadeIn}>
                        <motion.h2 className='general-heading text-3xl' variants={fadeIn}>İnsan, Bilgi ve Süreklilik</motion.h2>
                        <motion.p className='text-p text-gray-500' variants={fadeIn}>
                            Bugün Tedak; 66'dan fazla çalışanı, yıllık 1200+ saat teknik ve saha eğitimi ile sürekli gelişimi destekleyen bir organizasyon yapısına sahiptir.
                            <div className='h-3' />
                            Bilgiye yatırım yapan, sahadaki deneyimi mühendislikle birleştiren ve ekip içi uzmanlığı kurumsal hafızaya dönüştüren yapımız, sunduğumuz çözümlerin sürdürülebilirliğini güvence altına alır.
                        </motion.p>
                    </motion.div>

                    {/* Güçlü Mühendislik, Güvenilir Çözümler Section */}
                    <motion.div variants={fadeIn}>
                        <motion.h2 className='general-heading text-3xl' variants={fadeIn}>Güçlü Mühendislik, Güvenilir Çözümler</motion.h2>
                        <motion.p className='text-p text-gray-500' variants={fadeIn}>
                            Tedak Teknolojik Elektrik Dağıtım Kabinleri olarak; güçlü mühendislik altyapımız, ileri teknoloji çözümlerimiz ve güvenli üretim anlayışımızla, müşterilerimizin enerji sistemlerinde <strong>kesintisiz, verimli ve uzun ömürlü çözümler</strong> sunmaya devam ediyoruz.
                            <div className='h-3' />
                            Türkiye'de ve global pazarlarda, kalite, güven ve mühendislik disipliniyle anılan bir marka olma hedefiyle yolumuzu kararlılıkla sürdürüyoruz.
                        </motion.p>
                    </motion.div>

                </motion.div>
            </div>
        </div>
    )
}

export default Kurumsal
